import { IconButton } from "@material-ui/core";
import { EXCLUDE_QUIT_STAFF } from "app/appConfig";
import CommonButton from "app/common/Component/Button/CommonButton";
import TableComponent from "app/common/Component/Table/TableComponent";
import GlobitsPagingAutocomplete from "app/common/form/GlobitsPagingAutocomplete";
import { pagingStaff } from "app/services/StaffService";
import { FieldArray, useFormikContext, getIn } from "formik";
import { observer } from "mobx-react";
import { memo } from "react";
import IconDelete from "app/common/Icon/IconDelete";
import IconAddNew from "app/common/Icon/IconAddNew";
import { getCurrentStaff, getStaffGroupsUser } from "app/common/LocalFunction";

const ConsultantRow = ({ index, item, onRemove, departmentId }) => {
    const { values, setFieldValue } = useFormikContext();
    const staffValue = getIn(values, `listConsultant[${index}].staff`);
    const listConsultant = getIn(values, "listConsultant") || [];
    const currentUser = getCurrentStaff();
    console.log("🚀 ~ ConsultantRow ~ currentUser:", currentUser)
    // Get list of selected staff IDs (excluding current row)
    const selectedStaffIds = listConsultant
        .map((item, idx) => {
            if (idx !== index && item?.staff?.id) {
                return item.staff.id;
            }
            return null;
        })
        .filter((id) => id !== null);

    return (
        <tr className="row-table-body">
            <td className="text-center p-2" style={{ width: "50px" }}>
                {index + 1}
            </td>
            <td className="p-2">
                <GlobitsPagingAutocomplete
                    api={pagingStaff}
                    name={`listConsultant[${index}].staff`}
                    value={staffValue}
                    searchObject={{
                        isActive: true,
                        excludeStatus: EXCLUDE_QUIT_STAFF,
                        departmentId: departmentId || null,
                        //positionCodes: [POSITION_CONSULTANT],
                    }}
                    displayLabel="staffName"
                    displaySelected="id"
                    getOptionLabel={(option) =>
                        option
                            ? `${option.code || ""}${option.staffName ? " - " + option.staffName : ""}`
                            : ""
                    }
                    getOptionDisabled={(option) => {
                        // Disable if this staff is already selected in another row
                        return selectedStaffIds.includes(option?.id);
                    }}
                    onChange={(_, newValue) => {
                        // Update both staff and ensure type is set
                        setFieldValue(`listConsultant[${index}].staff`, newValue);
                        //setFieldValue(`listConsultant[${index}].type`, 1);
                    }}
                />
            </td>
            <td className="text-center p-2" style={{ width: "80px" }}>
                <IconButton
                    size="small"
                    onClick={() => onRemove(index)}
                    style={{ color: "#f44336" }}
                >
                    <IconDelete />
                </IconButton>
            </td>
        </tr>
    );
};

const ConsultantRowMemo = memo(observer(ConsultantRow));

const ConsultantTableSection = (() => {
    const { values, setFieldValue } = useFormikContext();
    const listConsultant = getIn(values, "listConsultant") || [];

    return (
        <FieldArray name="listConsultant">
            {({ push, remove }) => (
                <>
                    <div className="flex flex-column gap-1">
                        <div className="flex justify-between align-center">
                            <p className="mb-1 font-medium text-sm">
                                Danh sách nhân viên tư vấn
                            </p>
                            <CommonButton
                                className="btn-primary"
                                onClick={() => push({
                                    staff: null
                                    //,type: 1
                                })}
                            >
                                <IconAddNew color="#ffffff" className="mr-2" />
                                Thêm
                            </CommonButton>
                        </div>
                        <div className="table-root">
                            {listConsultant && listConsultant.length > 0 ? (
                                <div style={{ maxHeight: "200px", overflow: "auto" }}>
                                    <table className="table-container">
                                        <thead>
                                            <tr className="row-table-header header-gray">
                                                <th className="text-center p-2" style={{ width: "50px" }}>STT</th>
                                                <th className="p-2">Nhân viên tư vấn</th>
                                                <th className="text-center p-2" style={{ width: "80px" }}>Thao tác</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {listConsultant.map((item, index) => (
                                                <ConsultantRowMemo
                                                    key={`consultant-row-${index}`}
                                                    index={index}
                                                    item={item}
                                                    onRemove={remove}
                                                    departmentId={getIn(values, "department.id")}
                                                />
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            ) : (
                                <div className="p-5 text-center" style={{ color: "#999" }}>
                                    Danh sách nhân viên tư vấn đã chọn
                                </div>
                            )}
                        </div>
                    </div>
                </>
            )}
        </FieldArray>
    );
});

export default memo(observer(ConsultantTableSection));
